let DriftAPI = {
  showWelcomeMessage: null,
  hideWelcomeMessage: null,
  showWelcomeOrAwayMessage: null,
  openChat: null,
  hideChat: null,
  startInteraction: null
}

Object.keys(DriftAPI).map(function(method){
  const newFunc = function() {
    if (window.drift.api){
      window.drift.api[method].apply(null, arguments)
    } else {
      window.drift.on('ready', (api) => {
        api[method].apply(null, arguments)
      })
    }
  }
  DriftAPI[method] = newFunc
})

export default DriftAPI



// WEBPACK FOOTER //
// ./src/scripts/components/shared/DriftAPI/index.js